module.exports = __webpack_public_path__ + "static/media/eduRed.8a673f0a.svg";